import { render } from "./companyIntroduction.vue?vue&type=template&id=12e185e7&scoped=true"
import script from "./companyIntroduction.vue?vue&type=script&lang=js"
export * from "./companyIntroduction.vue?vue&type=script&lang=js"

import "./companyIntroduction.vue?vue&type=style&index=0&id=12e185e7&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e185e7"]])

export default __exports__